import { Typography } from '@/components/ui/typography';

export function Counter({ count }: { count: number }) {
  return (
    <div className="bg-fx-neutral-100 flex h-4 w-6 items-center justify-center rounded-full px-1">
      <Typography
        variant="small1"
        className="!text-fx-neutral-600 !font-medium"
      >
        {count}
      </Typography>
    </div>
  );
}
